import { render, staticRenderFns } from "./DefaultCommutatorTab.vue?vue&type=template&id=9507d43c&scoped=true&"
import script from "./DefaultCommutatorTab.vue?vue&type=script&lang=js&"
export * from "./DefaultCommutatorTab.vue?vue&type=script&lang=js&"
import style0 from "./DefaultCommutatorTab.vue?vue&type=style&index=0&id=9507d43c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9507d43c",
  null
  
)

export default component.exports